<template>
  <div class="v-team">
    <div class="header">
      <h2>{{$t('AboutText.p3_title')}}</h2>
    </div>
    <div class="content">
      <div class="left">
        <h5>{{$t('AboutText.p3_subtitle')}}</h5>
        <p>{{$t('AboutText.p3_content')}}</p>
      </div>
      <div class="right">
        <img src="../../assets/images/about/team-1.jpg"/>
        <img src="../../assets/images/about/team-2.jpg"/>
      </div>
    </div>
  </div>
</template>


<script>
    export default {
        name: "p3-team"
    }
</script>

<style scoped lang="scss">

  .en .v-team{
    .content{
      .right{
        padding-top: 3vw;
      }
    }
  }
  .v-team{
    text-align: left;
    padding: 4vw 10vw 6vw 17vw;
    .header{
      text-align: center;
      margin-bottom: 2.5vw;
      h2{
        font-size: 3.13vw;
        font-weight: bold;
      }
    }
    .content{
      display: flex;
      .left{
        padding: 0 4.5vw 0 0;
        h5{
          font-size: 1.25vw;
          font-weight: bold;
          margin-bottom: 2vw;
        }
        p{
          font-size: 1.25vw;
          line-height: 2.66vw;
        }
      }
      .right{
        display: flex;
        flex-shrink: 0;
        background-color: #ffffff;
        img{
          width: 13vw;
          height: 13vw;
          box-sizing: border-box;
          &:first-child{
            width: 15.5vw;
            padding-right: 2.5vw;
            border-right: 3px solid #1cbb9f;
          }
          &:last-child{
            margin-left: 2.5vw;
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/about/p3-team.vue